import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { empModulo } from '../../../diccionarios/empModulo';
import { UtilsService } from 'src/app/shared/utils/utils.service'; 
import { LfsaBotonEditarGridComponent } from 'src/app/shared/components/lfsa-boton-editar-grid/lfsa-boton-editar-grid.component'; 
import { EmpresasModel } from '../../../models/empresasModel';
import { EmpresasService } from '../../../services/administrador/empresas.service';

@Component({
  selector: 'app-empresas',
  templateUrl: './empresas.component.html',
  styleUrls: ['./empresas.component.css']
})
export class EmpresasEmpComponent implements OnInit {

  textoBuscar: string;
  resposiveFull: string;
  empModulo: any = {};
  formulario: FormGroup;//formulario
  columnDefs: any[];//aggrid
  rowData: EmpresasModel[] = [];
  frameworkComponents: any;
  gridApi: any;
  gridColumnApi: any;
  rowSelection: any;
  loading: boolean = false;
  listaVacia: boolean = true;
  dataEditar: EmpresasModel = new EmpresasModel();
  formularioEditar: FormGroup;
  nameArticulo: string;
  banderaArticulo: boolean;
  cmbGrupoColaborador:any[]=[];

  constructor(private fb: FormBuilder, private _util: UtilsService, 
              private _empresas: EmpresasService,
              private _router: Router) { }

  ngOnInit() {
    this.empModulo = empModulo;
    this.resposiveFull = this.empModulo.div.resposiveFull;
    this.formulario = this.fb.group({
      empresa: ['',[Validators.required]],
      codempresa: ['',[Validators.required,Validators.maxLength(6)]],
      grupofabril: ['',[Validators.required]],
    });
    this.formularioEditar = this.fb.group({
      empresa: ['',[Validators.required]],
      grupofabril: ['',[Validators.required]],
    });
    this.cargarGrid();
    this.getAllEmpresas();
    this.getAllGrupoFabril();
  }

  cargarGrid() {
    this.columnDefs = [
      {
        headerName: 'COD EMPRESA',
        field: 'codEmpresa',
        sortable: true,
        width: 300,
        filter: true
      },
      {
        headerName: 'DESCRIPCION',
        field: 'descripcion',
        sortable: true,
        filter: true,
        width: 250,
      },
      {
        headerName: '',
        cellRenderer: 'buttonRenderer',
        width: 200,
        cellRendererParams: {
          onClick: this.callEditarArticulo.bind(this),
          label: "Editar",
        }
      },
      {
        headerName: '',
        cellRenderer: 'buttonRenderer',
        width: 200,
        cellRendererParams: {
          onClick: this.deleteArticulo.bind(this),
          label: "Eliminar",
        }
      },

    ];

    this.frameworkComponents = {
      buttonRenderer: LfsaBotonEditarGridComponent,
    };

    this.rowSelection = 'multiple';
  }

  onQuickFilterChanged() {
    this.gridApi.setQuickFilter(this.textoBuscar);
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  }

  /*getArticuloId(){
    this._empresas.getArticuloId(this.formulario.get('articulo').value).subscribe((res: any) => {
     if(Object.entries(res).length === 0){
      this.nameArticulo = 'No se encontro el articulo';
      this.banderaArticulo = false;
     } else {
      this.nameArticulo = res.dsca;
      this.banderaArticulo = true;
     }
    }, (err) => {
      this.banderaArticulo = false;
      this.nameArticulo = 'No se encontro el articulo';
      console.log(err);
      this._util.mensajeErrorVisto(err.error.message);
    });
  }*/

  getAllEmpresas() {
    this.loading = true;
    this._empresas.getAllEmpresas().subscribe((res: EmpresasModel[]) => {
      this.loading = false;
      this.rowData = res;
      if (this.rowData.length > 0) {
        this.listaVacia = false;
      } else {
        this.listaVacia = true;
      }
      console.log(res);
    }, (err) => {
      console.log(err);
      this.loading = false;
      this.listaVacia = true;
    });
  }

  getAllGrupoFabril(){
    this.cmbGrupoColaborador = [{"grupoFabril":1,"descripcion":"SI"},{"grupoFabril":0,"descripcion":"NO"}];
  }

  seleccionGrupoNew(){
    console.log(this.formulario.get('grupofabril').value);
  }

  seleccionGrupoEdit(){
    console.log(this.formularioEditar.get('grupofabril').value);
  }

  agregarArticulo() {
    let empresas: EmpresasModel = new EmpresasModel();
    empresas.descripcion = this.formulario.get('empresa').value;
    empresas.codEmpresa = this.formulario.get('codempresa').value;
    empresas.grupoFabril = this.formulario.get('grupofabril').value;
    this._util.confirmarSincronoPromesaNormal(
      {
        title: 'Está seguro que desea guardar la siguiente empresa?',
        text: '',
        action: 'Guardar',
        funcion: this._empresas.postEmpresas(empresas),
        loading: true,
        context: this,
      }
    ).then((res: any) => {
      console.log(res);
      this.getAllEmpresas();
      document.getElementById('cerrarModal').click();
      this.formulario.reset();
      this.nameArticulo = '';
      this.banderaArticulo = null;
    }).catch((err) => { 
      console.log('Error ' + err);
      this._util.mensajeErrorVisto(err.error.message); 
    });
  }

  deleteArticulo({rowData}) {
    this._util.confirmarSincronoPromesaNormal(
      {
        title: 'Está seguro que desea eliminar la siguiente empresa?',
        text: '',
        action: 'Eliminar',
        funcion: this._empresas.deleteEmpresa(rowData.codEmpresa),
        loading: true,
        context: this,
      }
    ).then((res: any) => {
      console.log(res);
      this.getAllEmpresas();
    }).catch((err) => { 
      console.log('Error ' + err);
      this._util.mensajeErrorVisto(err.error.message); 
    });
  }

  callModal(){
    document.getElementById('abrirModal').click();
  }

  callEditarArticulo({rowData}){
    this.dataEditar = rowData;
    this.formularioEditar.get('empresa').setValue(this.dataEditar.descripcion);
    this.formularioEditar.get('grupofabril').setValue(this.dataEditar.grupoFabril);
    document.getElementById('abrirModalEditar').click();
  }

  editarArticulo() {
    this.dataEditar.descripcion = this.formularioEditar.get('empresa').value;
    this.dataEditar.grupoFabril = this.formularioEditar.get('grupofabril').value;
    this._util.confirmarSincronoPromesaNormal(
      {
        title: 'Está seguro que desea editar la siguiente Empresa?',
        text: '',
        action: 'Editar',
        funcion: this._empresas.updatetEmpresas(this.dataEditar),
        loading: true,
        context: this,
      }
    ).then((res: any) => {
      console.log(res);
      document.getElementById('cerrarModalEditar').click();
      this.formularioEditar.reset();
      this.dataEditar = new EmpresasModel();
      this.getAllEmpresas();
    }).catch((err) => { 
      console.log('Error ' + err);
      this._util.mensajeErrorVisto(err.error.message); 
    });
  }

}
